import { Col, Row, Button } from 'antd';
import React from 'react';
import AdminHeader from '../../globals/Layout/Admin/AdminHeader';
import CardChangePassword from './CardChangePassword/CardChangePassword';
const ChangePassword: React.FC = () => {
    return (
        <div>
            <AdminHeader>Cambiar contraseña</AdminHeader>
            <CardChangePassword typeCard={"-admin"} terms={false} id={""} />           
        </div>

    );
};


export default ChangePassword;